import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ProductCard, theme } from '@notino/react-styleguide';

import { useFormatPrice } from '@components/PriceLabel/useFormattedPrice';
import { messages } from '@components/Universals/ProductItem/messages';
import { IVoucherDiscount } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/VoucherDiscount/VoucherDiscount';
import { styled } from '@linaria/react';

type Props = {
  voucherDiscount: IVoucherDiscount;
};

const VoucherCode = styled.strong`
  color: ${theme.color.text.primary};
  font-weight: 700 !important;
`;

export const ProductTileDiscount = ({ voucherDiscount }: Props) => {
  const formatPrice = useFormatPrice();

  function getVoucherDiscountDecoration() {
    if (voucherDiscount?.tags?.includes('summerblackfriday')) {
      return 'summerBlackFriday';
    }
    if (voucherDiscount?.tags?.includes('blackfriday')) {
      return 'blackFriday';
    }
  }

  const DiscountComponent = ProductCard.Discount;

  if (!DiscountComponent) {
    return null;
  }

  return (
    <DiscountComponent
      decoration={getVoucherDiscountDecoration()}
      discountAmount={
        formatPrice({
          value: voucherDiscount.discountedPrice,
        })!.formattedPriceWithCurrency
      }
      discountDescription={
        <FormattedMessage
          {...messages.voucherDescriptionText}
          values={{
            code: <VoucherCode>{voucherDiscount.code}</VoucherCode>,
          }}
        />
      }
    />
  );
};
